<template>
    <svg-icon @click="copy" icon="link-45deg"></svg-icon>
</template>
<script>
import {useClipboard} from '@vueuse/core';
import SvgIcon from "./SvgIcon.vue";
import {notify} from "@kyvg/vue3-notification";

export default {
    components: {SvgIcon},
    props: ['url'],
    methods: {
        copy() {
            const source = this.url;
            const {text, copy, copied, isSupported} = useClipboard({source: this.url, legacy: true});

            copy(source);

            if (copied) {
                notify({
                    type: 'success',
                    text: 'Скопировано',
                });
            } else {
                notify({
                    type: 'error',
                    text: 'Не удалось скопировать. Возможно твой браузер старше чем Зоибана',
                });
            }
        }
    }
}
</script>